export class Bulletin {
  public bulletinId: number;
  public name: string;
  public type: string
  public date: Date;
  public article: string;
  public analysis: string;
  public recommendedActions: string;
  public areaIds: number;
  public areaNames: number;

  tenantName:string;
}
